"use client"
/* */
import z from 'zod';

class Sorting {
  static storageSchema = z.object({
    direction: z.enum(["asc", "desc"]),
    property: z.string().or(z.number())
  }).optional();
  list;
  property;
  name;
  direction;
  defaultEnabled;
  customSortingFn;
  constructor(list, shape) {
    this.list = list;
    this.property = shape.property;
    this.name = shape.name;
    this.direction = shape.direction ?? "asc";
    const storedDefaultEnabled = this.getStoredDefaultEnabled();
    this.defaultEnabled = shape.defaultEnabled === "hidden" ? "hidden" : storedDefaultEnabled ?? shape.defaultEnabled ?? false;
    this.customSortingFn = shape.customSortingFn;
  }
  getStoredDefaultEnabled() {
    const storedSorting = this.list.getStoredSortingDefaultSetting();
    if (!storedSorting) {
      return void 0;
    }
    return storedSorting.property === this.property && storedSorting.direction === this.direction;
  }
  updateTableColumnDef(def) {
    def.enableSorting = true;
    if (this.customSortingFn) {
      def.sortingFn = this.customSortingFn;
    }
  }
  getReactTableColumnSort() {
    return {
      id: this.property,
      desc: this.direction === "desc"
    };
  }
  isSorted() {
    const col = this.getTableColumn();
    return col.getIsSorted() == this.direction;
  }
  getTableColumn() {
    return this.list.reactTable.getTableColumn(this.property);
  }
  enable() {
    this.list.reactTable.getTableColumn(this.property).toggleSorting(this.direction === "desc", false);
    this.list.storeSortingSettings(this);
  }
  clear() {
    this.list.reactTable.getTableColumn(this.property).clearSorting();
  }
  get id() {
    return `${this.getTableColumn().id}:${this.direction}`;
  }
}

export { Sorting };
//# sourceMappingURL=Sorting.mjs.map
